import { Link } from 'react-router-dom';
import { useLiveQuery } from 'dexie-react-hooks';
import { EMPTY, type FieldAssignment } from '@kilroy/shared';
import { db } from '../db/db';
import { useSession } from '../app/session';
import { useUsers } from '../hooks/useUsers';
import { AssignmentCard } from '../components/AssignmentCard';

/* Everything routed to you, plus everything left open to the team.
 *
 * Open-to-team assignments are shown to everyone rather than hidden until
 * claimed — with seven people, a queue nobody can see is a queue nobody
 * empties. */

export function Assigned() {
  const { user } = useSession();
  const { userById } = useUsers();

  const assignments = useLiveQuery(() => db.assignments.toArray(), [], [] as FieldAssignment[]);
  const evidence = useLiveQuery(() => db.evidence.toArray(), [], []);

  const mine = assignments.filter(
    (a) => a.assigned_to === user.id && a.current_status !== 'completed' && a.current_status !== 'dismissed',
  );
  const open = assignments.filter(
    (a) => !a.assigned_to && a.current_status === 'open',
  );
  const done = assignments.filter(
    (a) =>
      a.assigned_to === user.id &&
      (a.current_status === 'completed' || a.current_status === 'dismissed'),
  );

  return (
    <div className="screen">
      <div className="screen__h">
        <h1 className="screen__t">Assigned</h1>
        <p className="screen__s">
          {mine.length} yours · {open.length} open to the team
        </p>
      </div>

      <section className="mod">
        <div className="mod__h">
          <h2 className="label">Routed to you</h2>
          {mine.length > 0 && <span className="mod__n">{mine.length}</span>}
        </div>
        {mine.length === 0 ? (
          <div className="card empty">
            <div className="empty__t">{EMPTY.assignments}</div>
            <div className="empty__h">
              Capture anything you find — it doesn’t need an assignment.
            </div>
            <Link to="/capture" className="btn btn--primary empty__a">
              Capture something
            </Link>
          </div>
        ) : (
          mine.map((a) => (
            <AssignmentCard
              key={a.id}
              assignment={a}
              evidence={evidence}
              author={userById(a.created_by)}
            />
          ))
        )}
      </section>

      {open.length > 0 && (
        <section className="mod">
          <div className="mod__h">
            <h2 className="label">Open to the team</h2>
            <span className="mod__n">{open.length}</span>
          </div>
          {open.map((a) => (
            <AssignmentCard
              key={a.id}
              assignment={a}
              evidence={evidence}
              author={userById(a.created_by)}
            />
          ))}
        </section>
      )}

      {done.length > 0 && (
        <section className="mod">
          <div className="mod__h">
            <h2 className="label">Closed</h2>
            <span className="mod__n">{done.length}</span>
          </div>
          {done.map((a) => (
            <AssignmentCard
              key={a.id}
              assignment={a}
              evidence={evidence}
              author={userById(a.created_by)}
            />
          ))}
        </section>
      )}
    </div>
  );
}
